import { crmService } from '../services/crmApi';
import { navigateToProductLocation } from './productNavigation';

export const OPERATION_SESSION_BACKUP_KEY = 'superadmin_token_backup';
export const FINANCE_REQUESTED_VIEW_KEY = 'finance_requested_view';
export const COMPANY_VIEW_CONTEXT_KEY = 'crm_company_view_context';
export const COMPANY_VIEW_CONTEXT_EVENT = 'company-view-context:changed';

type SwitchCompanyOptions = {
  authTokenOverride?: string;
  redirectPath?: string;
  requestedView?: string;
  adminTab?: string;
};

type RestorePrimaryOperationOptions = {
  redirectPath?: string;
  requestedView?: string;
};

const normalizeStoredValue = (value?: string | null) => {
  const normalized = String(value || '').trim();
  return normalized || null;
};

export function getSelectedCompanyViewContextId() {
  if (typeof window === 'undefined') {
    return null;
  }

  if (localStorage.getItem(OPERATION_SESSION_BACKUP_KEY)) {
    return null;
  }

  return normalizeStoredValue(localStorage.getItem(COMPANY_VIEW_CONTEXT_KEY));
}

export function setSelectedCompanyViewContextId(companyId?: string | null) {
  if (typeof window === 'undefined') {
    return;
  }

  const normalized = normalizeStoredValue(companyId);

  if (!normalized) {
    localStorage.removeItem(COMPANY_VIEW_CONTEXT_KEY);
    return;
  }

  localStorage.setItem(COMPANY_VIEW_CONTEXT_KEY, normalized);
}

export async function switchToSubcompanyOperation(
  companyId: string,
  options: SwitchCompanyOptions = {}
) {
  const {
    authTokenOverride,
    redirectPath,
    requestedView,
    adminTab
  } = options;

  const response = await crmService.impersonateSubcompany(companyId, authTokenOverride);
  const currentToken = authTokenOverride || localStorage.getItem('token');

  if (!currentToken) {
    throw new Error('Sessão atual não encontrada.');
  }

  if (!localStorage.getItem(OPERATION_SESSION_BACKUP_KEY)) {
    localStorage.setItem(OPERATION_SESSION_BACKUP_KEY, currentToken);
  }

  if (adminTab) {
    localStorage.setItem('adminActiveTab', adminTab);
  }

  if (requestedView) {
    localStorage.setItem(FINANCE_REQUESTED_VIEW_KEY, requestedView);
  } else {
    localStorage.removeItem(FINANCE_REQUESTED_VIEW_KEY);
  }

  localStorage.setItem('token', response.token);

  const targetPath = String(redirectPath || '').trim() || '/dashboard';
  navigateToProductLocation(targetPath);
}

export function restorePrimaryOperationSession(options: RestorePrimaryOperationOptions = {}) {
  const {
    redirectPath = '/dashboard',
    requestedView
  } = options;
  const primaryToken = localStorage.getItem(OPERATION_SESSION_BACKUP_KEY);

  if (primaryToken) {
    localStorage.setItem('token', primaryToken);
  } else {
    localStorage.removeItem('token');
  }

  localStorage.removeItem(OPERATION_SESSION_BACKUP_KEY);
  if (requestedView) {
    localStorage.setItem(FINANCE_REQUESTED_VIEW_KEY, requestedView);
  } else {
    localStorage.removeItem(FINANCE_REQUESTED_VIEW_KEY);
  }
  navigateToProductLocation(redirectPath);
}
